export const AppConstants= {
    COMMON_DMAIL: 'rx4@rxcarenet.org',
    PATIENTEMAIL: 'rx5759@rxcarenet.org',
    PATIENTDOB: '2018-04-13',
    TOKEN:'b2F1dGhfdG9rZW49U1lRVTlNRjNmaG53VGJVbUpIOHEmb2F1dGhfdG9rZW5fc2VjcmV0PXlSblVmYWFUV3ZLYmptWlpVd3VpJmFjY291bnRfaWQ9cng0JTQwcnhjYXJlbmV0Lm9yZw==',
    TIME_INTERVAL:5,
    NUMBER_SEARCH: {
        MODE: 5,
        DMAIL: "rx4@rxcarenet.org"
    },
    TIME_SEARCH: {
    		MODE: 6,
    		DOCMAIL: "rx4@rxcarenet.org",
    		DOC_ID: '',
    		BDATE: ''
    },
    APPOINTMENT: {
        MODE_ALL: 0,
        MODE_DATE:1
    },
    ORDER: {
        MODE: 2
    },
    SESSION_KEY: {
        APPOINTMENT_LIST: 'APPOINTMENT_LIST'
    },
    COUNTRY_Params: {
        demail: "rx4@rxcarenet.org",
        mode: 0
    },
    STATE_Params: {
        demail: "rx4@rxcarenet.org",
        mode: 5
    },
    CITY_Params: {
        demail: "rx4@rxcarenet.org",
        mode: 2
    },
    LOC_Params: {
        demail: "rx4@rxcarenet.org",
        mode: 3
    },
    LANGG_Params: {
        demail: "rx4@rxcarenet.org",
        mode: 6,
    },
    DOCTOR_Params : {
        demail: "rx4@rxcarenet.org",
        mode: 4,
    }
}
